import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../reducers/types";
import { fetchVacationRentalShop } from "../../actions/actions";
import {
  getVacationRentalShopCallState,
  getVacationRentalShopSelectedListing,
  getVacationRentalListPrice,
} from "../../reducer";

import { withRouter } from "react-router";
import { ShopCta } from "./component";
import { getUserSelectedAccountReferenceId, getSelectedAccountReferenceId } from "../../../rewards/reducer";
import {
  getAdultsCount,
  getChildren,
  getFromDate,
  getNightCount,
  getPetsCount,
  getUntilDate,
} from "../../../search/reducer";
import { setOccupancyCounts } from "../../../search/actions/actions";

const mapStateToProps = (state: IStoreState) => ({
  shopCallState: getVacationRentalShopCallState(state),
  selectedListing: getVacationRentalShopSelectedListing(state),
  listPrice: getVacationRentalListPrice(state),
  selectedRewardsAccount: getUserSelectedAccountReferenceId(state),
  selectedRewardsAccountWithFallback: getSelectedAccountReferenceId(state),
  fromDate: getFromDate(state),
  untilDate: getUntilDate(state),
  lengthOfStay: getNightCount(state),
  numAdults: getAdultsCount(state),
  numChildren: getChildren(state),
  numPets: getPetsCount(state),
});

const mapDispatchToProps = {
  fetchVacationRentalShop,
  setOccupancyCounts,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type VacationRentalShopConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedShopCta = withRouter(connector(ShopCta));
